module.exports = __webpack_public_path__ + "img/wock.dfe2c3bb.png";